import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import { defer, LoaderFunctionArgs } from 'react-router-dom'
import useStockStore from 'src/components/routes/stock/store'
import { getOldWorkflowRedirect } from '../../helper'

export default async function loader(loaderFunctionArgs: LoaderFunctionArgs) {
  const purchaseOrderId = loaderFunctionArgs.params.purchaseOrderId ?? ''
  const oldWorkflowRedirect = getOldWorkflowRedirect(
    `/stock/purchaseorder/active/edit/${purchaseOrderId}`
  )
  if (oldWorkflowRedirect) return oldWorkflowRedirect

  logger.debug(
    '[loader] About to await AppState being ready in Edit Purchase Order loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Edit Purchase Order loader'
  )

  // Manually reset slices until Tim's automatic route-exit reset is in place
  useStockStore.getState().resetPurchaseOrderSlice()
  useStockStore.getState().resetEditPurchaseOrdersSlice()

  const items = useStockStore.getState().getItems()

  const brands = useStockStore.getState().getBrands()

  const suppliers = useStockStore.getState().getSuppliers()

  const units = useStockStore.getState().getStockUnits()

  const subcategories = useStockStore.getState().getSubcategories()

  const salesTax = useStockStore.getState().getSalesTax()

  const invoiceDataPromise = useStockStore
    .getState()
    .initializePurchaseOrderData(loaderFunctionArgs)

  // Return a deferred promise to enable React Router's built-in loading state
  // This approach is currently required for compatibility with our PageLoadingSupport.tsx logic,
  // even though defer() is considered legacy in newer React Router versions.
  return defer({
    data: Promise.all([
      items,
      brands,
      suppliers,
      units,
      subcategories,
      salesTax,
      invoiceDataPromise,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Edit Purchase Order error: ', error)
        return false
      }),
  })
}
